import { Select } from "antd";
import { AddDeleteButton } from "components/SeasonView/components/AddDeleteButton";
import { useSharedColumnBuilder } from "hooks/useSharedColumnBuilder";
import { useSportConfiguration } from "hooks/useSportConfiguration";
import { useIntl } from "react-intl";

type Props = {
  onAdd: (record: any) => void;
  onDelete: (record: any) => void;
  getAlreadyAdded: (record: any) => any;
  checkIfRecordBeingBusy: (record: any) => boolean;
};

export const useAddPeopleStaffColumns = ({ onAdd, onDelete, getAlreadyAdded, checkIfRecordBeingBusy }: Props) => {
  const { formatMessage } = useIntl();
  const {
    createPersonNameColumn,
    createPersonDobColumn,
    createPersonNationalityColumn,
    createPersonStatusColumn,
    createGenderColumn,
  } = useSharedColumnBuilder();
  const { configuration } = useSportConfiguration();

  const checkIfAlreadyAdded = (record: any) => !!getAlreadyAdded(record);

  return [
    createPersonNameColumn({ checkIfAlreadyAdded }),
    createPersonDobColumn({ withSorter: false }),
    createPersonNationalityColumn(),
    createGenderColumn(),
    createPersonStatusColumn(),
    {
      title: formatMessage({ id: "columns.staff.role" }),
      align: "center",
      dataIndex: "role",
      width: 250,
      render: (_, record) => {
        const alreadyAdded = getAlreadyAdded(record);
        if (alreadyAdded) {
          return alreadyAdded.role ? formatMessage({ id: `role.${alreadyAdded.role}` }) : "";
        }
        return (
          <Select
            onChange={(value) => {
              record.role = value;
            }}
            placeholder={formatMessage({ id: "select.staffRole.placeholder" })}
            style={{ width: "150px" }}
            showSearch
            defaultValue={record.role}
            disabled={checkIfRecordBeingBusy(record)}
            defaultActiveFirstOption={true}
            options={configuration.seasonStaffRoles.map((x) => {
              return {
                value: x,
                label: formatMessage({ id: `role.${x}` }),
                dcPersonId: record?.dcPersonId,
                personId: record?.personId,
              };
            })}
          />
        );
      },
    },
    {
      render: (_, record) => (
        <AddDeleteButton
          isLoading={checkIfRecordBeingBusy(record)}
          isAdd={!checkIfAlreadyAdded(record)}
          onAdd={() => onAdd(record)}
          onDelete={() => onDelete(record)}
        />
      ),
      width: 50,
    },
  ];
};
